import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "label", "maxFieldWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CopyToClipboard from 'react-copy-to-clipboard';
import Flex, { Box } from 'components/Flex';
import { AlertTypes } from 'components/Alert';
import Button from 'components/Button';
import FormField from 'components/FormField';
import { StyledInput } from 'components/TextInput';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function selectAllText(_ref) {
  var target = _ref.target;
  setTimeout(function () {
    target.select();
  }, 0);
}
export default function CopyToClipboardField(_ref2) {
  var value = _ref2.value,
    label = _ref2.label,
    maxFieldWidth = _ref2.maxFieldWidth,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    wasCopied = _useState2[0],
    setWasCopied = _useState2[1];
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    label: label,
    alert: wasCopied ? t('alert_copied_to_clipboard') : undefined,
    alertType: wasCopied ? AlertTypes.SUCCESS : undefined
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsxs(Flex, {
      maxWidth: maxFieldWidth,
      children: [/*#__PURE__*/_jsx(Box, {
        grow: true,
        shrink: true,
        children: /*#__PURE__*/_jsx(StyledInput, {
          readOnly: true,
          type: "text",
          value: value,
          onFocus: selectAllText
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(CopyToClipboard, {
          text: value,
          onCopy: function onCopy() {
            return setWasCopied(true);
          },
          children: /*#__PURE__*/_jsx(Button, {
            variant: "transparent",
            icon: "asset",
            ml: "xxs",
            children: t('actions_copy')
          })
        })
      })]
    })
  }));
}